/**
 * Sample data generator utility
 * This will populate the localStorage with initial data for new users
 */

// Add a function to generate dates within a range
const randomDate = (start, end) => {
  // Use default values if parameters are undefined
  const startDate = start || new Date(new Date().setDate(new Date().getDate() - 30));
  const endDate = end || new Date();
  
  return new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime())).toISOString().split('T')[0];
};

// Generate random amount
const randomAmount = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// Document statuses with weighted probability
const documentStatuses = ['paid', 'paid', 'paid', 'pending', 'pending', 'overdue'];

// Initialize with real sample data
export const initializeSampleData = () => {
  // Check if already initialized or explicitly prevented
  const initialized = localStorage.getItem('facit_initialized');
  const preventSampleData = localStorage.getItem('prevent_sample_data');
  
  if (initialized === 'true' || preventSampleData === 'true') {
    console.log("Sample data initialization skipped - already initialized or explicitly prevented");
    return;
  }
  
  console.log("Creating brand new sample data...");
  
  // Sample products data
  const products = [
    { 
      id: 1, 
      name: 'تطوير موقع إلكتروني', 
      description: 'إنشاء موقع متجاوب مع نظام إدارة المحتوى',
      type: 'service',
      category: 'خدمات تقنية المعلومات',
      price: 250000,
      unit: 'حزمة',
      sku: 'SRV-001',
      stock: null,
      status: 'active'
    },
    { 
      id: 2, 
      name: 'حاسوب محمول Dell', 
      description: 'Dell Latitude 7420، i7، 16GB RAM، 512GB SSD',
      type: 'product',
      category: 'معدات تقنية المعلومات',
      price: 185000,
      unit: 'وحدة',
      sku: 'MAT-002',
      stock: 4, // Low stock to trigger notification
      status: 'active'
    },
    { 
      id: 3, 
      name: 'تدريب React.js', 
      description: 'تدريب شامل على React.js - 40 ساعة',
      type: 'service',
      category: 'تدريب',
      price: 75000,
      unit: 'جلسة',
      sku: 'FOR-003',
      stock: null,
      status: 'active'
    },
    { 
      id: 4, 
      name: 'خادم HP ProLiant', 
      description: 'خادم HP ProLiant DL380 Gen10',
      type: 'product',
      category: 'معدات تقنية المعلومات',
      price: 450000,
      unit: 'وحدة',
      sku: 'MAT-004',
      stock: 3,
      status: 'active'
    },
    { 
      id: 5, 
      name: 'تدقيق أمني لتقنية المعلومات', 
      description: 'تدقيق شامل للأمن السيبراني',
      type: 'service',
      category: 'استشارات',
      price: 120000,
      unit: 'يوم',
      sku: 'CON-005',
      stock: null,
      status: 'active'
    },
    { 
      id: 6, 
      name: 'شاشة 27 بوصة 4K', 
      description: 'شاشة Dell UltraSharp 27 بوصة',
      type: 'product',
      category: 'معدات تقنية المعلومات',
      price: 65000,
      unit: 'وحدة',
      sku: 'MAT-006',
      stock: 12,
      status: 'active'
    }
  ];
  
  // Sample clients data
  const clients = [
    {
      id: 1,
      clientNumber: '01',
      type: 'company',
      name: 'شركة التقنية المتقدمة',
      contactPerson: 'محمد العتيبي',
      address: '15 شارع الملك فهد، حي العليا',
      city: 'الرياض',
      postalCode: '11564',
      country: 'المملكة العربية السعودية',
      phone: '+966-11-234-5678',
      email: 'contact@advancedtech.sa',
      registrationNumber: '1010123456',
      taxNumber: '300123456789003',
      fiscalId: '300123456789003',
      vatNumber: '300123456789003',
      cr: '1010123456',
      contactPhone: '+966-55-123-4567',
      notes: 'عميل منتظم',
      status: 'active',
      createdDate: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 3)), new Date()),
      lastOrder: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()),
      totalOrders: 12,
      totalAmount: 285000
    },
    {
      id: 2,
      clientNumber: '02',
      type: 'individual',
      name: 'د. فاطمة الحربي',
      contactPerson: '',
      address: '22 شارع التحلية، حي الروضة',
      city: 'جدة',
      postalCode: '21442',
      country: 'المملكة العربية السعودية',
      email: 'f.alharbi@gmail.com',
      phone: '+966-12-456-7890',
      registrationNumber: '',
      taxNumber: '300987654321003',
      fiscalId: '',
      vatNumber: '300987654321003',
      contactPhone: '+966-55-987-6543',
      category: 'الصحة',
      status: 'active',
      createdDate: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 2)), new Date()),
      lastOrder: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()),
      totalOrders: 5,
      totalAmount: 67500
    },
    {
      id: 3,
      clientNumber: '03',
      type: 'company',
      name: 'شركة ابتكار ذ.م.م',
      contactPerson: 'كريم الدوسري',
      address: '05 طريق الملك عبدالعزيز',
      city: 'الدمام',
      postalCode: '32211',
      country: 'المملكة العربية السعودية',
      email: 'contact@innovcorp.sa',
      phone: '+966-13-876-5432',
      registrationNumber: '2050987654',
      taxNumber: '300456789123003',
      fiscalId: '300456789123003',
      vatNumber: '300456789123003',
      cr: '2050987654',
      contactPhone: '+966-55-111-2233',
      category: 'خدمات',
      status: 'active',
      createdDate: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()),
      lastOrder: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()),
      totalOrders: 8,
      totalAmount: 145000
    }
  ];
  
  // Update the generateRandomDocuments function to include proper dates
  const generateRandomDocuments = (count, clients, products) => {
    const documents = [];
    const now = new Date();
    const pastYear = new Date();
    pastYear.setFullYear(now.getFullYear() - 1);

    const types = ['invoice', 'quote', 'proforma'];
    const statuses = ['pending', 'paid', 'overdue'];
    
    // Counters for each document type
    const documentCounters = {
      'invoice': 1,
      'quote': 1,
      'proforma': 1
    };

    for (let i = 0; i < count; i++) {
      // Create a document with a recent date for better chart data
      const randomClient = clients[Math.floor(Math.random() * clients.length)];
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      
      // Use weighted status distribution: 60% paid, 30% pending, 10% overdue
      const statusRand = Math.random();
      const status = statusRand < 0.6 ? 'paid' : (statusRand < 0.9 ? 'pending' : 'overdue');
      
      // Generate date based on status
      let docDate;
      if (status === 'paid') {
        // Paid documents spread over the past year
        docDate = randomDate(pastYear, now);
      } else if (status === 'pending') {
        // Pending documents are more recent (last 3 months)
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(now.getMonth() - 3);
        docDate = randomDate(threeMonthsAgo, now);
      } else {
        // Overdue documents are between 3-6 months old
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(now.getMonth() - 6);
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(now.getMonth() - 3);
        docDate = randomDate(sixMonthsAgo, threeMonthsAgo);
      }
      
      // Generate a random amount - weighted toward reasonable numbers
      const baseAmount = 1000 + Math.floor(Math.random() * 5000);
      const multiplier = Math.floor(Math.random() * 5) + 1;
      const amount = baseAmount * multiplier;
      
      const type = types[Math.floor(Math.random() * types.length)];
      
      // Add some operation IDs for testing operations view
      let operationId = null;
      let operationName = null;
      if (i < 3) {
        // First 3 documents belong to "Commercial operation"
        operationId = 'OP-COMMERCIAL-001';
        operationName = 'عملية تجارية';
      } else if (i >= 3 && i < 6) {
        // Next 3 documents belong to another operation
        operationId = 'OP-MENSUEL-001';
        operationName = 'عملية شهرية';
      }
      
      documents.push({
        id: `doc_${i + 1}`,
        number: type === 'invoice' ? `FAC-${documentCounters.invoice.toString().padStart(2, '0')}` :
                type === 'quote' ? `DEV-${documentCounters.quote.toString().padStart(2, '0')}` :
                type === 'proforma' ? `PRO-${documentCounters.proforma.toString().padStart(2, '0')}` :
                `DOC-${(i + 1).toString().padStart(2, '0')}`,
        type: type,
        client: randomClient.name,
        clientId: randomClient.id,
        date: docDate,
        dueDate: docDate, // Simplification
        category: randomProduct.category,
        operationId: operationId,
        operationName: operationName,
        items: [
          {
            id: randomProduct.id,
            name: randomProduct.name,
            quantity: Math.floor(Math.random() * 5) + 1,
            price: randomProduct.price,
          }
        ],
        status: status,
        amount: amount,
        taxRate: 0.15,
        notes: ""
      });
      
      // Increment counter for this document type
      if (documentCounters[type]) {
        documentCounters[type]++;
      }
    }

    // Make sure we have at least 5 paid documents in the last 30 days for the chart
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(now.getDate() - 30);
    
    const recentPaidDocs = documents.filter(doc => 
      doc.status === 'paid' && 
      new Date(doc.date) >= thirtyDaysAgo
    );
    
    if (recentPaidDocs.length < 5) {
      const neededDocs = 5 - recentPaidDocs.length;
      
      for (let i = 0; i < neededDocs; i++) {
        const randomClient = clients[Math.floor(Math.random() * clients.length)];
        const randomProduct = products[Math.floor(Math.random() * products.length)];
        
        const docDate = randomDate(thirtyDaysAgo, now);
        const amount = 5000 + Math.floor(Math.random() * 20000);
        
        documents.push({
          id: `doc_recent_${i + 1}`,
          number: `FAC-${documentCounters.invoice.toString().padStart(2, '0')}`,
          type: 'invoice',
          client: randomClient.name,
          clientId: randomClient.id,
          date: docDate,
          dueDate: docDate,
          category: randomProduct.category,
          items: [
            {
              id: randomProduct.id,
              name: randomProduct.name,
              quantity: Math.floor(Math.random() * 5) + 1,
              price: randomProduct.price,
            }
          ],
          status: 'paid',
          amount: amount,
          taxRate: 0.15,
          notes: "مستند حديث لبيانات الرسم البياني"
        });
        
        // Increment invoice counter
        documentCounters.invoice++;
      }
    }
    
    return documents;
  };

  // Generate documents
  const documents = generateRandomDocuments(20, clients, products);
  
  // Save sample data to localStorage
  localStorage.setItem('facit_products', JSON.stringify(products));
  localStorage.setItem('facit_clients', JSON.stringify(clients));
  localStorage.setItem('facit_documents', JSON.stringify(documents));
  
  // Mark as initialized
  localStorage.setItem('facit_initialized', 'true');
  
  console.log('Sample data initialized:', {
    products: products.length,
    clients: clients.length,
    documents: documents.length
  });
  
  // Return generated data
  return {
    products,
    clients,
    documents
  };
}; 
